import { render } from "./FoodView.vue?vue&type=template&id=315d2958"
import script from "./FoodView.vue?vue&type=script&lang=js"
export * from "./FoodView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__